module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bill"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.data.list), function(note) {
    return _c('div', {
      key: note.id,
      staticClass: "bill-item"
    }, [_c('div', [_vm._v(_vm._s(note.currency_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(note.trans_amount + '币'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(note.currency_rate))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("ticket_curr")(note)))])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.periodCurrPersonalSummary && _vm.data.periodCurrPersonalSummary.confirm_money < 0),
      expression: "data.periodCurrPersonalSummary && data.periodCurrPersonalSummary.confirm_money < 0"
    }],
    staticClass: "bill-item bill-total"
  }, [_c('div', [_vm._v("上期结余")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("bonus")(_vm.data.periodCurrPersonalSummary)))])]), _vm._v(" "), _c('div', {
    staticClass: "bill-item bill-total"
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("bonus")(_vm.data.currPersonalSummary)))])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bill-head"
  }, [_c('div', [_vm._v("快币类型")]), _vm._v(" "), _c('div', [_vm._v("数量(币)")]), _vm._v(" "), _c('div', [_vm._v("汇率")]), _vm._v(" "), _c('div', [_vm._v("金额")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-59f39868!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/bill.vue
// module id = 746
// module chunks = 1